import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[620px] md:h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylized%20abstract%20creative%20background%20with%20geometric%20shapes%20in%20warm%20orange%20and%20teal%20tones%2C%20smooth%20gradients%2C%20modern%20minimalist%20design%2C%20subtle%20texture%2C%20digital%20creative%20platform%20atmosphere%2C%20clean%20and%20artistic%2C%20soft%20flowing%20shapes%2C%20tech%20creative%20vibe&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="黄瓜视频 - 短视频创作与分享平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-md border border-background-50/20 mb-6">
            <div className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></div>
            <span className="text-background-50 text-sm">超过5000万用户的选择</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight">
            记录精彩生活
            <br />
            分享无限创意
          </h1>

          <p className="text-base md:text-lg text-background-200/80 mb-8 max-w-xl mx-auto leading-relaxed">
            黄瓜视频——专业的短视频创作与分享平台。海量优质内容、智能剪辑工具、活跃创作者社区，让你的每一份创意都被世界看见。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/about"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line mr-2"></i>
              立即下载APP
            </Link>
            <Link
              to="/category/gaoxiao"
              className="px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-md border border-background-50/30 text-background-50 font-semibold text-sm hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line mr-2"></i>
              浏览精彩内容
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-10">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50">5000万+</div>
              <div className="text-xs text-background-300 mt-1">注册用户</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50">100万+</div>
              <div className="text-xs text-background-300 mt-1">活跃创作者</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50">10亿+</div>
              <div className="text-xs text-background-300 mt-1">日均播放量</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}